import * as React from 'react'
import getRankDataConfig from './getRankDataConfig'
import styles from './index.module.scss'
import classNames from 'classnames'
interface IRankFlag {
  className?: string
  style?: React.CSSProperties
  textStyle?: React.CSSProperties
  textClassName?: string
}
export default React.memo(function RankPublishFlag({
  className,
  style,
  textClassName,
  textStyle,
}: IRankFlag) {
  const [visible, setVisible] = React.useState(false)
  React.useEffect(() => {
    ;(async () => {
      const config = await getRankDataConfig()
      setVisible(!!config?.is_publish_time)
    })()
  }, [])
  if (!visible) {
    return null
  }
  return (
    <span className={classNames(styles.root, className)} style={style}>
      <span
        className={classNames(styles.text, textClassName)}
        style={textStyle}
      >
        发榜日
      </span>
    </span>
  )
})
